import Class from './Class';

export default class ClassWrapper {
    constructor() {

    }
    public classes: Array<Class>;
    public datesSelected: string;
}